import {
  EVENTS,
  USER_PROFILE_PHOTO,
  GROUP_MESSAGE,
  CASE_AVATAR,
  CONSULT_REQUEST,
  OCCUPATIONAL_HEALTH_PDF,
  EMPLOYER_LOGO,
} from '../../constants/objectTypes';
import {
  EVENT_FILE_SINGLE_DOWNLOAD,
  EVENT_FILE_UPLOADS,
  USER_PROFILE_PHOTO_UPLOAD,
  USER_PROFILE_PHOTO_DOWNLOAD,
  GROUP_MESSAGE_FILE_UPLOAD,
  GROUP_MESSAGE_FILE_DOWNLOAD,
  CASE_AVATAR_FILE_UPLOAD,
  CASE_AVATAR_FILE_SINGLE_DOWNLOAD,
  CONSULT_REQUEST_FILE_UPLOADS,
  CONSULT_REQUEST_FILE_SINGLE_DOWNLOAD,
  OCC_HEALTH_PDF_UPLOADS,
  OCC_HEALTH_PDF_DOWNLOAD,
  OCC_HEALTH_PDF_DELETE,
  EMPLOYER_LOGO_UPLOAD,
} from '../../constants/fileResources';
import {
  // COMPONENT_ADD_FILE_SERVER_FAILURE,
  // COMPONENT_ADD_FILE_SERVER_REQUEST,
  // COMPONENT_ADD_FILE_SERVER_SUCCESS,
  // COMPONENT_PRE_SIGN_URL_FOR_UPLOAD_FAILURE,
  // COMPONENT_PRE_SIGN_URL_FOR_UPLOAD_REQUEST,
  // COMPONENT_PRE_SIGN_URL_FOR_UPLOAD_SUCCESS,
  // COMPONENT_UPLOAD_FILE_FAILURE,
  // COMPONENT_UPLOAD_FILE_REQUEST,
  // COMPONENT_UPLOAD_FILE_SUCCESS,
  RESET_COMPONENT_STATE,
  COMPONENT_UPLOAD_AND_SAVE_FILES_PENDING,
  COMPONENT_UPLOAD_AND_SAVE_FILES_REQUEST,
  COMPONENT_UPLOAD_AND_SAVE_FILES_SUCCESS,
  COMPONENT_UPLOAD_AND_SAVE_FILES_FAILURE,
  COMPONENT_GET_FILE_SERVER_REQUEST,
  COMPONENT_GET_FILE_SERVER_SUCCESS,
  COMPONENT_GET_FILE_SERVER_FAILURE,
  COMPONENT_ADD_FILE_SERVER_REQUEST,
  COMPONENT_ADD_FILE_SERVER_SUCCESS,
  COMPONENT_ADD_FILE_SERVER_FAILURE,
  COMPONENT_REMOVE_FILE_SERVER_REQUEST,
  COMPONENT_REMOVE_FILE_SERVER_SUCCESS,
  COMPONENT_REMOVE_FILE_SERVER_FAILURE,
  COMPONENT_REMOVE_FILE_ENTRY_LOCALLY,
} from '../../actions/actionTypes';
import {
  getPreSignedUrlsForUpload,
  uploadMultipleFilesToS3,
  saveFilesMetaDataToServer as saveFilesMetaDataToServerService,
  getFileByTypeAndId as getFileByTypeAndIdService,
  deleteFile as deleteFileService,
} from '../../services/fileService';

import { imageExt } from '../../helpers/images';

export function resetState() {
  return { type: RESET_COMPONENT_STATE };
}

export function resetUploadStateForObject(objectType, objectId) {
  return {
    type: RESET_COMPONENT_STATE,
    payload: { objectType, objectId },
  };
}

export function setUploadStatePendingForObject(objectType, objectId) {
  return {
    type: COMPONENT_UPLOAD_AND_SAVE_FILES_PENDING,
    payload: { objectType, objectId },
  };
}

export function getResourceFromObjectType(objectType, upload, remove) {
  switch (objectType) {
    case EVENTS:
      if (upload) return EVENT_FILE_UPLOADS;
      else return EVENT_FILE_SINGLE_DOWNLOAD;
      break;
    case USER_PROFILE_PHOTO:
      if (upload) return USER_PROFILE_PHOTO_UPLOAD;
      else return USER_PROFILE_PHOTO_DOWNLOAD;
      break;
    case GROUP_MESSAGE:
      if (upload) return GROUP_MESSAGE_FILE_UPLOAD;
      else return GROUP_MESSAGE_FILE_DOWNLOAD;
      break;
    case CASE_AVATAR:
      if (upload) return CASE_AVATAR_FILE_UPLOAD;
      else return CASE_AVATAR_FILE_SINGLE_DOWNLOAD;
      break;
    case CONSULT_REQUEST:
      if (upload) return CONSULT_REQUEST_FILE_UPLOADS;
      return CONSULT_REQUEST_FILE_SINGLE_DOWNLOAD;
      break;
    case OCCUPATIONAL_HEALTH_PDF:
      if (upload) return OCC_HEALTH_PDF_UPLOADS;
      if (remove) return OCC_HEALTH_PDF_DELETE;
      return OCC_HEALTH_PDF_DOWNLOAD;
      break;
    case EMPLOYER_LOGO:
      if (upload) return EMPLOYER_LOGO_UPLOAD;
      break;
  }
}

export function deleteFile(objectType, objectId, fileName, fileId) {
  const preSignedUrlsObj = {
    objectId: objectId,
    resource: getResourceFromObjectType(objectType, false, true),
    fileName,
  };

  return {
    types: [
      COMPONENT_REMOVE_FILE_SERVER_REQUEST,
      COMPONENT_REMOVE_FILE_SERVER_SUCCESS,
      COMPONENT_REMOVE_FILE_SERVER_FAILURE,
    ],
    promise: deleteFileService(preSignedUrlsObj, objectType, fileId),
  };
}

export function uploadFilesAndSaveToServer(
  objectType,
  objectId,
  files,
  compress = false,
  skipMetaData = false
) {
  return function (dispatch, getState) {
    dispatch({
      type: COMPONENT_UPLOAD_AND_SAVE_FILES_REQUEST,
      payload: { objectType, objectId },
    });

    return _fileMetaData(files)
      .then((metaData) => {
        // console.info(
        //   '======================== uploadImagesAndSaveToServer 1',
        //   objectType,
        //   objectId,
        //   metaData
        // );

        return getPreSignedUrlsForImagesUpload(objectType, objectId, metaData).then(
          ({ files: filesPreSignedUrls }) => {
            // console.info('got signedUrls  --- ', filesPreSignedUrls);
            const filesToUpload = filesPreSignedUrls.map((fs, i) => {
              return {
                imageData: files[i].image,
                fileUrl: fs.url,
                fileName: fs.fileName,
                fileComment: files[i].comment,
                fileExtension: metaData[i].fileExtension,
                isHeic: metaData[i].isHeic,
              };
            });
            // console.info('filesToUpload before  uploadFilesToS3 ', filesToUpload);
            return uploadFilesToS3(filesToUpload, compress).then(() => {
              const filesToSave = filesToUpload.map((fs) => {
                delete fs.imageData;
                return fs;
              });
              // console.info('uploadedFiles', filesToSave);
              if (skipMetaData) {
                dispatch({
                  type: COMPONENT_UPLOAD_AND_SAVE_FILES_SUCCESS,
                  payload: { objectType, objectId, files: filesToSave },
                });
                return;
              }
              return dispatch(saveFilesMetaDataToServer(objectType, objectId, filesToSave)).then(
                (response) => {
                  dispatch({
                    type: COMPONENT_UPLOAD_AND_SAVE_FILES_SUCCESS,
                    payload: { objectType, objectId, files: response },
                  });
                }
              );
            });
          }
        );
      })
      .catch((e) => {
        console.info('uploadFilesAndSaveToServer error', e);

        dispatch({
          type: COMPONENT_UPLOAD_AND_SAVE_FILES_FAILURE,
          payload: { objectType, objectId, errorMessage: e.message },
        });

        console.error('Error uploading files and/or saving metadata', e);
      });
  };
}

function _fileMetaData(files) {
  const promises = files.map((file) => {
    return imageExt(file.image).then((extension) => {
      return {
        fileExtension: extension === 'heic' ? 'jpg' : extension,
        isHeic: extension === 'heic',
        fileName: file.image.fileName,
      };
    });
  });
  return Promise.all(promises);
}

function getPreSignedUrlsForImagesUpload(objectType, objectId, files) {
  const preSignedUrlsObj = {
    objectType: objectType,
    resource: getResourceFromObjectType(objectType, true),
    files: files,
    objectId: objectId,
  };

  return getPreSignedUrlsForUpload(preSignedUrlsObj);
  // return {
  //   types: [
  //     COMPONENT_PRE_SIGN_URL_FOR_UPLOAD_REQUEST,
  //     COMPONENT_PRE_SIGN_URL_FOR_UPLOAD_SUCCESS,
  //     COMPONENT_PRE_SIGN_URL_FOR_UPLOAD_FAILURE,
  //   ],
  //   promise: getPreSignedUrlsForUpload(preSignedUrlsObj),
  //   throwError: true,
  // };
}

function uploadFilesToS3(filesToUpload, compress = false) {
  return uploadMultipleFilesToS3(filesToUpload, compress);
  // return {
  //   types: [
  //     COMPONENT_UPLOAD_FILE_REQUEST,
  //     COMPONENT_UPLOAD_FILE_SUCCESS,
  //     COMPONENT_UPLOAD_FILE_FAILURE,
  //   ],
  //   promise: uploadMultipleFilesToS3(filesToUpload),
  //   throwError: true,
  // };
}

function saveFilesMetaDataToServer(objectType, objectId, files) {
  return function (dispatch, getState) {
    return dispatch({
      types: [
        COMPONENT_ADD_FILE_SERVER_REQUEST,
        COMPONENT_ADD_FILE_SERVER_SUCCESS,
        COMPONENT_ADD_FILE_SERVER_FAILURE,
      ],
      promise: saveFilesMetaDataToServerService(objectType, objectId, files),
      throwError: true,
    });
  };
}

export function getFileByTypeAndId(objectType, objectId) {
  return {
    types: [
      COMPONENT_GET_FILE_SERVER_REQUEST,
      COMPONENT_GET_FILE_SERVER_SUCCESS,
      COMPONENT_GET_FILE_SERVER_FAILURE,
    ],
    promise: getFileByTypeAndIdService(objectType, objectId),
  };
}

export function removeFileEntryFromReduxAndFirebase(objectType, objectId) {
  return function (dispatch, getState) {
    dispatch({
      type: COMPONENT_REMOVE_FILE_ENTRY_LOCALLY,
      payload: { objectType: objectType, objectId: objectId },
    });
  };
}
